export function calculateExpiresAt(expiresIn: number): number {
  return expiresIn * 1000 + new Date().getTime() - 60 * 1000;
}
